import { React, useState } from 'react'
import { Space, TimePicker, message } from 'antd';
import DaySelector from '../../GeneralComponents/DaySelector';
import { Modal, Form, Input, Switch, Select } from 'antd';
import styles from "./styles.module.css"
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import { timeZone } from '../../resources/LocationData';

function DynamicTimeRangeAddition({ dynamicRanges, setDynamicRanges, setIsDynamicRateAddfieldVisible, selLocation,sharedFieldVisible,setLocationData }) {
    console.log("existing charger dynamic rates in rate addition component", dynamicRanges)
    const [timeRange, setTimeRange] = useState([]);
    const [freeCharging, setFreecharging] = useState(false)
    const [rate, setRate] = useState(0)
    const [form] = Form.useForm();
    const [dynamicRateApplicableDays, setDynamicRatesApplicableDays] = useState([0, 0, 0, 0, 0, 0, 0])
    const [addRateBtnDisable, setAddRateBtnDisable] = useState(true)
    const [rateFieldDisable, setRateFieldDisable] = useState(false)

    const convertToTimezone = (timeString, targetZone) => {
        
        const [start, end] = timeString.split('-');
        console.log("timezone ", targetZone);
        const getDateWithTime = (time) => {
            const [hours, minutes, seconds] = time.split(':');
            const date = new Date();
            date.setUTCHours(hours);
            date.setUTCMinutes(minutes);
            date.setUTCSeconds(seconds);
            return date;
        };

        const formatTime = (date, timeZone) => {
            return date.toLocaleString('en-US', {
                timeZone: timeZone,
                hour12: false,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        };

        const startTimeDate = getDateWithTime(start);
        const endTimeDate = getDateWithTime(end);

        // console.log("Start Date Time (UTC):", startTimeDate);
        // console.log("End Date Time (UTC):", endTimeDate);

        const convertedStartTime = formatTime(startTimeDate, targetZone);
        const convertedEndTime = formatTime(endTimeDate, targetZone);

        const startTimeInTargetZone = new Date(convertedStartTime);
        const endTimeInTargetZone = new Date(convertedEndTime);

        return `${convertedStartTime} - ${convertedEndTime}`;
    };


    function checkTimeConflict(newTimeRange, existingTimeRanges) {
        // Split the new time range into start and end times
        console.log(newTimeRange,existingTimeRanges)
        let [newStart, newEnd] = newTimeRange.split('-').map(parseTime);
        console.log(newStart,newEnd)
        // Loop through existing time ranges and check for conflicts
        for (const slot of existingTimeRanges) {
            if(slot.freeCharging === false){
                let [existingStart, existingEnd] = slot.timeRange.split('-').map(parseTime);

                if(newEnd <= newStart){
                    newEnd = new Date(newEnd).setDate(new Date(newEnd).getDate() + 1)
                }
                if(existingEnd <= existingStart){
                    existingEnd = new Date(existingEnd).setDate(new Date(existingEnd).getDate() + 1)
                    console.log(new Date(existingStart), new Date(existingEnd))
                }
                console.log(newStart,newEnd,existingStart,existingEnd)
                // Check if new time overlaps with the existing time range
                if (
                    (newStart >= existingStart && newStart < existingEnd) ||  // New start is within existing range
                    (newEnd > existingStart && newEnd <= existingEnd) ||      // New end is within existing range
                    (newStart <= existingStart && newEnd >= existingEnd)      // New range fully overlaps existing range
                ) {
                    return true; // Conflict found
                }
            }
            
        }
        
        return false; // No conflict
    }

    function parseTime(timeString) {
        console.log("timestring",timeString)
        const [hours, minutes, secondsWithMillis] = timeString.split(':');
        const [seconds, milliseconds] = secondsWithMillis.split('.');
        const date = new Date();
        date.setHours(hours, minutes, seconds, milliseconds);
        console.log("date: ", date)
        return date.getTime(); // Return the time in milliseconds
    }



    const handleTimeChange = (times) => {
       
        if (times === null) {
            setTimeRange([]);
            setAddRateBtnDisable(true)
        }
        if (times && times.length === 2) {
            const formattedTimeRange = times.length === 2
                ? times.map((t, index) => convertToUTC(new Date(t), index)).join('-')
                : '';
            console.log("formatted time range", formattedTimeRange)
            console.log("location time zone", selLocation.timezone)
            setTimeRange(times)
            setAddRateBtnDisable(false)
          


        } else {
            setTimeRange([]);
        }

    };
    const getSelectedDayForNewDynamicRate = (newDateRange) => {
        console.log("new dynamic rate fiedl added with selected days: ")
        console.log(newDateRange)
        setDynamicRatesApplicableDays(newDateRange)
    }



    function getTargetZoneOffset(timeZone, date = new Date()) {
        try {
            const formatter = new Intl.DateTimeFormat('en-US', {
                timeZone,
                hour12: false,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
    
            const parts = formatter.formatToParts(date);
            const hourPart = parts.find(part => part.type === 'hour');
            const minutePart = parts.find(part => part.type === 'minute');
    
            const hour = parseInt(hourPart.value, 10);
            const minute = parseInt(minutePart.value, 10);
    
            // Get UTC time
            const utcHour = date.getUTCHours();
            const utcMinute = date.getUTCMinutes();
    
            const hourOffset = hour - utcHour;
            const minuteOffset = minute - utcMinute;
    
            return (hourOffset * 60) + minuteOffset; // Offset in minutes
        } catch (e) {
            console.error('Failed to calculate timezone offset:', e);
            return 0; 
        }
    }



    function convertToUTC(timestamp, index) {
       const date = new Date(new Date(timestamp).getTime()-(getTargetZoneOffset(selLocation.timezone, new Date(timestamp))*60000));
        date.setSeconds(0)
        date.setMilliseconds(0)
        
        let updatedDate = index === 0 ? new Date(date) :(timestamp.getHours()===23 && timestamp.getMinutes()===59)?new Date(date.getTime()+ 59999): new Date(date.getTime()-1)
       
        const utcYear = updatedDate.getUTCFullYear();
        const utcMonth = (updatedDate.getUTCMonth() + 1).toString().padStart(2, '0'); 
        const utcDay = updatedDate.getUTCDate().toString().padStart(2, '0');
        let utcHours = updatedDate.getHours().toString().padStart(2, '0');
        let utcMinutes = updatedDate.getMinutes().toString().padStart(2, '0');
        let utcSeconds = updatedDate.getSeconds().toString().padStart(2, '0');
        let utcMilliseconds = updatedDate.getMilliseconds().toString().padStart(3, '0');

        

        return `${utcHours}:${utcMinutes}:${utcSeconds}.${utcMilliseconds}`;
    }

    const addDynamicRate = () => {
        const formattedTimeRange = timeRange.length === 2
            ? timeRange.map((t, index) => convertToUTC(new Date(t), index)).join('-')
            : '';

        // const newDynamicRate = {
        //     applicableDays: dynamicRateApplicableDays,
        //     freeCharging: freeCharging,
        //     rate: rate,
        //     timeRange: formattedTimeRange,
        // };
        const newDynamicRate = sharedFieldVisible?
        {
            applicableDays: dynamicRateApplicableDays,
            timeRange: formattedTimeRange
        }
        :
        {
                applicableDays: dynamicRateApplicableDays,
                freeCharging: freeCharging,
                rate: rate,
                timeRange: formattedTimeRange,
            }


        console.log('New Dynamic rate: ', newDynamicRate);

        console.log(checkTimeConflict(newDynamicRate.timeRange, dynamicRanges))

        if(sharedFieldVisible===true || newDynamicRate.freeCharging === false){
            let conflictCheck = checkTimeConflict(newDynamicRate.timeRange, dynamicRanges)
            if (conflictCheck === true){
                message.error(`The selected time range is conflicting with an existing dynamic time range.`)
                return 
            }
        }

        
        setDynamicRanges([...dynamicRanges, newDynamicRate]);

        {sharedFieldVisible && setLocationData((obj) => ({
            ...obj, 
            sharedTime: [...dynamicRanges, newDynamicRate]
        }))};


        form.resetFields();
        setTimeRange([]);
        setRate(0);
        setFreecharging(false);
        setDynamicRatesApplicableDays([0, 0, 0, 0, 0, 0, 0]);
        setIsDynamicRateAddfieldVisible(false)
        //'{applicableDays: (7) [0, 1, 1, 0, 0, 0, 0], freeCharging: false, rate: 0.45, timeRange: "05:15:00-05:25:00", _id :"66e51e80f61e5e46eb524a75" }'
    }

    function handleFreeCharging(checked) {
        if (checked) {
            setRate(0)
            setRateFieldDisable(true)
        } else {
            setRateFieldDisable(false)
        }

    }

    return (
        <div className={styles.dynamicRateFormDiv}>
            <Form form={form} layout={'vertical'} onFinish={addDynamicRate}>

                <Form.Item label="Time Range">
                    <Space direction="vertical">
                        <TimePicker.RangePicker
                            status="success"
                            onChange={handleTimeChange}
                            value={timeRange}
                            showSecond={false}
                        />
                    </Space>

                    
                </Form.Item>

                {
                    !sharedFieldVisible?
                <Form.Item label="Free Charging" valuePropName="checked">
                    <Switch
                        checked={freeCharging}
                        onChange={(checked) => { setFreecharging(checked); handleFreeCharging(checked) }}
                    />
                </Form.Item>:
                <></>
                }

                {
                    !sharedFieldVisible?
                    <Form.Item label="Rate">
                    <Input type="number" step="0.1" disabled={rateFieldDisable} value={rate} onChange={(e) => setRate(e.target.value)} />
                    </Form.Item>
                    :
                    <></>
                }
              

                <Form.Item label="Enabled Days">
                    <DaySelector chargerDynamicRateApplicableDays={dynamicRateApplicableDays} onSelectedDayChange={getSelectedDayForNewDynamicRate} rateIndex={0} />
                </Form.Item>

                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right' }}>
                        <ButtonCustom disabled={addRateBtnDisable} text={!sharedFieldVisible?"Add Rate":"Add Shared Selection"} onClick={() => { addDynamicRate() }} />
                    </Form.Item>
                </div>

            </Form>
        </div>
    )
}

export default DynamicTimeRangeAddition